<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('class_entity.title')"
              label-for="class_entity">
              <validation-provider
                #default="{ errors }"
                :name="$t('class_entity.title')"
                rules="required">
                <v-select id="class_entity"
                          v-model="classEntity"
                          :options="classEntityList"
                          label="short_name_fmt"
                          class="required-select">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('class_entity.number')"
              label-for="number">
              <validation-provider
                #default="{ errors }"
                :name="$t('class_entity.number')"
                rules="required">
                <b-form-input
                  id="number"
                  v-model="number"
                  :state="errors.length > 0 ? false:null"
                  name="number"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <b-button
              v-if="editMode"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="cancelEdit"
              class="float-right">
              Limpar
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :class="['float-right', {'mr-2': editMode}]"
              :disabled="!validateForm">
              {{this.editMode ? 'Alterar' : 'Adicionar'}}
            </b-button>

          </div>
        </div>
      </b-form>
    </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="peopleClassEntityList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Entidade de classe</vs-th>
            <vs-th>Número</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].class_entity.short_name_fmt}}</vs-td>
              <vs-td>{{data[indextr].number}}</vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="EditIcon"
                    title="Editar"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-warning"
                    @click="edit(data[indextr])"/>
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'

import vSelect from 'vue-select'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    teacherId: {
      type: Number,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    id: null,
    classEntity: null,
    number: null,
    classEntityList: [],
    peopleClassEntityList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        // !this.errors.any() && //vee-validate-fix
        this.classEntity !== null &&
        !this.isEmpty(this.number)
      )
    }
  },
  watch: {},
  methods: {
    save() {

      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            people_id: this.people_id,
            class_entity_id: this.classEntity.id,
            number: this.number,
          }

          if (this.editMode) {
            params['id'] = this.id
          }

          this.services.teacherService.saveClassEntity(this.teacherId, params).then(
            data => {
              this.$vs.loading.close()
              this.loadData()
              this.editMode = false
              this.clearFields()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })
    },
    destroy(entity) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(entity)
        }
      })
    },
    acceptDestroy(entity) {
      this.$vs.loading()
      this.services.teacherService.deleteClassEntity(this.teacherId, entity.id).then(
          data => {
            this.$vs.loading.close()
            this.peopleClassEntityList = this.peopleClassEntityList.filter(element => {
              return element.id !== entity.id
            })

            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    edit(entity) {
      this.editMode = true
      this.id = entity.id
      this.classEntity = entity.class_entity
      this.number = entity.number
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.classEntity = null
      this.number = null
    },
    loadData() {
      this.services.teacherService.getAllClassEntities(this.teacherId).then(
        response => {
          this.peopleClassEntityList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    }
  },
  beforeMount() {
    this.$vs.loading()

    const promisses = []

    promisses.push(
      this.services.classEntityService.all().then(
        data => {
          this.classEntityList = data
        },
        error => {this.$vs.loading.close()}
      )
    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  },
  beforeDestroy() {

  },
  mounted() {
    this.loadData()
  }
}
</script>
